<template lang="pug">
  transition(name="kmdl-modal")
    .kmdl-container(v-if="isOpen")
      form.modal-form(@submit.prevent="confirm()")
        .kmdl-dialog
          .kmdl-header
            .title {{title}}
            .close-btn(v-if="closeable" @click="cancel()")
              i.fa.fa-close
          .kmdl-body
            slot
              .default {{message}}
          .kmdl-footer
            slot(name="footer")
              button.btn.btn-default(type="button" @click="cancel()") Cancel
              button.btn.btn-primary(type="submit") {{confirmButtonText || 'OK'}}
</template>

<script>
import Vue from 'vue'

export default {
  props: ['title', 'message', 'closeable', 'confirmButtonText'],
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    open() {
      this.isOpen = true
      // focus primary button
      Vue.nextTick(() => {
        if (document.activeElement) {
          document.activeElement.blur()
        }
        const focusElement = this.$el.querySelector('.focus')
        if (focusElement) {
          focusElement.focus()
        }
      })
    },
    close() {
      this.isOpen = false
    },
    cancel() {
      this.$emit('cancel')
      this.close()
    },
    confirm() {
      this.$emit('confirm')
      this.close()
    },
    handleKeyDown(e) {
      if (this.isOpen) {
        switch (e.key) {
          case 'Escape':
            this.cancel()
            break
          default:
            break
        }
      }
    }
  }
}
</script>

<style lang="scss">
.kmdl-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 998;
  background: rgba(128, 128, 128, 0.5);
  .kmdl-dialog {
    border-radius: 3px;
    background: white;
    border: solid gray 1px;
    box-shadow: 1px 1px 1px 1px gray;
    padding: 10px;
    .kmdl-header {
      font-size: 18px;
      border-bottom: solid #ececec 1px;
      display: flex;
      .title {
        flex: 1
      }
      .close-btn {
        cursor: pointer;
        opacity: 0.2;
        &:hover {
          opacity: 0.8;
        }
      }
    }
    .kmdl-body {
      min-width: 200px;
      max-height: 80vh;
      padding: 10px;
    }

    .kmdl-footer {
      border-top: solid #ececec 1px;
      padding-top: 5px;
      text-align: right;
      button {
        margin-left: 5px;
      }
    }
  }
  transition: .3s
}
.kmdl-modal-enter {
  opacity: 0;
}
.kmdl-modal-enter-active {
  opacity: 1;
}
.kmdl-modal-leave-active {
  opacity: 0;
}
.kmdl-modal-enter-active .kmdl-dialog {
  animation: modal-appear-in .2s
}

@keyframes modal-appear-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Modal.vue